import { render, staticRenderFns } from "./PhraseRendererComponent.vue?vue&type=template&id=2bf00bf0&scoped=true"
import script from "./PhraseRendererComponent.vue?vue&type=script&lang=js"
export * from "./PhraseRendererComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf00bf0",
  null
  
)

export default component.exports